export const detectBrowserLanguage = () => {
  // When multilang is disabled, always use English
  if (process.env['MULTILANG'] !== 'true') {
    return 'en'
  }

  const languageFromLocalStorage = localStorage.getItem('language')

  if (languageFromLocalStorage) {
    return languageFromLocalStorage
  }

  if (navigator.language.startsWith('en')) {
    return 'en'
  }

  return 'ru'
}
